import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import Pages from "../../components/Pages";
import FormSection from "../../components/FormSection";
import * as AppActions from "../../actions";
import ReactModal from "react-modal";
import { Form, Icon, Button, Loader } from "semantic-ui-react";
import MobilePages from "../../components/MobilePages";
import RenameDraft from "../../components/RenameDraft";
import ApproveReject from "../../components/ApproveReject";
import { geolocated } from "react-geolocated";
import compose from "recompose/compose";
import _ from "lodash";
import { Document, Page } from "react-pdf";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactDOM from "react-dom";
import disableBrowserBackButton from "disable-browser-back-navigation";
import { CheckRule } from "../../common";
import TaskEditor from "../../components/TaskEditor";

const customStyles = {
  content: {
    top: "50%",
    width: "700px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    height: "85%",
    backgroundColor: "#e6e6e6",
    border: "0px",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

const customStylesApp = {
  content: {
    top: "50%",
    width: "700px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    height: "85%",
    backgroundColor: "transparent",
    border: "0px",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

const customStylesPreview = {
  content: {
    width: "100%",
    height: "100%",
    top: "0px",
    padding: "0px",
    borderRadius: "0px",
    left: "0px",
    backgroundColor: "#e6e6e6",
    border: "0px"
  }
};

const customStylesRename = {
  content: {
    top: "50%",
    width: "85%",
    maxWidth: "400px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    border: "0px",
    height: "260px",
    backgroundColor: "#fff",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

const customStylesApproval = {
  content: {
    top: "50%",
    width: "85%",
    maxWidth: "400px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    border: "0px",
    height: "370px",
    backgroundColor: "#fff",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

class FormContainer extends Component {
  constructor() {
    super();

    this.state = {
      width: 800,
      height: 182,
      formControls: [],
      pageNums: [],
      loading: false,
      approver: "",
      repeatingFormControls: [],
      approverModalVisible: false,
      approveRejectModalVisible: false,
      uuid: "",
      printedSelected: false,
      status: "",
      filterText: "",
      modalVisible: false,
      numPages: 0,
      draftModalVisible: false,
      isDraft: false,
      showMenu: false,
      taskEditModal: false
    };
    this.controls = [];
    this.tablet = window.innerWidth - 40 < 650 ? false : true;
    disableBrowserBackButton();
    global.x = [];
    global.y = [];
  }

  loadControls() {
    const { match, test, actionQueue } = this.props;
    const { uuid, result_id } = match.params;

    if (
      result_id !== "" &&
      result_id !== undefined &&
      result_id !== "undefined" &&
      result_id !== "copy" &&
      uuid.indexOf("!") === -1
    ) {
      let draft = _.filter(actionQueue, function(data) {
        return (
          data.result_id.toString() === result_id.toString() &&
          data.isDraft === true &&
          data.test === test
        );
      });
      if (draft.length === 0) {
        this.abort();
      } else {
        this.props.actions
          .draftExists(
            result_id,
            draft[0].draftName,
            draft[0].form_id,
            draft[0].form_version,
            draft[0].date_added,
            draft[0].date_modified
          )
          .then(result => {
            if (result) {
              this.loadControls_do();
            }
          });
      }
    }

    if (
      result_id === "" ||
      result_id === undefined ||
      result_id === "undefined" ||
      result_id === "copy" ||
      uuid.indexOf("!") !== -1
    ) {
      this.loadControls_do();
    }
  }

  loadControls_do() {
    const { formControlArray, match } = this.props;
    const { form_id, form_version } = match.params;

    var formControls = _.filter(formControlArray, { formId: form_id });
    try {
      if (formControls[0].data.length > 0) {
        this.props.actions.getFormControls(
          formControls[0].data,
          form_id,
          form_version
        );
      }
    } catch (e) {
      this.props.actions.getFormControls(null, form_id, form_version);
    }
  }

  componentWillMount() {
    this.setState({ uuid: this.props.match.params.uuid.replace("!", "") });
    this.loadControls();
  }
  componentDidMount() {
    this.updateDimensions();
    ReactDOM.findDOMNode(this).scrollIntoView();
    const list = ReactDOM.findDOMNode(this.refs.divScrollx);
    list.addEventListener("scroll", this._handleScroll.bind(this));
  }

  handleBack() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to exit this form?",
      buttons: [
        {
          label: "OK",
          onClick: () => this.goBack(false, true)
        },
        {
          label: "Cancel",
          onClick: () => {}
        }
      ]
    };

    confirmAlert(options);
  }

  showConfirmStatus(status) {
    let msg = "This form has been " + status;
    const options = {
      title: "Confirmation",
      message: msg,
      buttons: [
        {
          label: "OK",
          onClick: () => this.goBack(true)
        }
      ]
    };

    confirmAlert(options);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.postingStatus === "doneForm") {
      this.props.actions.setPostingStatus("");
      this.setState({ approveRejectModalVisible: false });
      this.showConfirmStatus(this.state.status === 2 ? "rejected" : "approved");
    } else {
      if (!newProps.exists && newProps.isLoading) {
        this.abort();
      } else {
        if (this.props.preview !== newProps.preview) {
          if (newProps.preview !== "[fetching]" && newProps.preview !== "") {
            this.setModalVisible(true);
            setTimeout(() => {
              this.setState({ showMenu: false });
            }, 0);
          } else {
            this.setModalVisible(false);
          }
        }

        if (newProps.submitted) {
          this.props.actions.savedForm("");
          setTimeout(() => {
            this.showConfirmAuto();
          }, 0);
        } else {
          if (
            newProps.errors.length > 0 &&
            newProps.repeatingFormId === -1 &&
            newProps.showMsg
          ) {
            const options = {
              title: "Incomplete",
              message: "Please complete all the mandatory fields.",
              buttons: [
                {
                  label: "OK",
                  onClick: () => this.props.actions.updateShowMsg(false)
                }
              ]
            };

            confirmAlert(options);
          } else {
            if (
              newProps.repeatingFormErrors.length > 0 &&
              newProps.repeatingFormId !== -1 &&
              newProps.showMsgRepeat
            ) {
              const options = {
                title: "Incomplete",
                message: "Please complete all the mandatory fields.",
                buttons: [
                  {
                    label: "OK",
                    onClick: () => this.props.actions.updateShowMsgRepeat(false)
                  }
                ]
              };

              confirmAlert(options);
            }
          }
        }
      }
    }
  }

  goBack(forms = false, backClick = false) {
    if (
      this.props.match.params.isDraft === undefined  &&
      this.props.match.params.outbox === undefined 
    ) {
      this.props.history.push("/forms");
      if (backClick) {
        this.props.actions.resetImages(
          this.state.uuid,
          false,
          this.state.isDraft
        );
      }
    } else {
      if (forms) {
        this.props.history.push("/forms");
      } else {
        if (!(this.props.match.params.outbox === undefined)) {
          this.props.history.push("/outbox");
        } else {
          if (this.props.match.params.uuid.indexOf("!") !== -1) {
            if (this.props.match.params.approver == "true") {
              this.props.history.push("/approvals");
            } else {
              this.props.history.push("/sent");
            }
          } else {
            this.props.history.push("/drafts");
          }
        }
        if (backClick) {
          this.props.actions.resetImages(
            this.props.match.params.uuid,
            true,
            this.state.isDraft
          );
        }
      }
    }

    this.props.actions.resetForm();
  }

  abort() {
    const { result_id } = this.props.match.params;

    let header = "Form has been removed";
    let msg = "Exit and sync forms with server";
    if (result_id !== "") {
      header = "Draft has been removed";
      msg = "Exit and sync drafts with server";
      this.props.actions.updateFormExists(true);
      this.props.actions.readDrafts();
    }

    const options = {
      title: header,
      message: msg,
      buttons: [
        {
          label: "OK",
          onClick: () => {
            this.props.history.push("/forms");
          }
        }
      ]
    };

    confirmAlert(options);
  }

  showConfirmAuto() {
    if (this.state.isDraft) {
      const options = {
        title: "Confirmation",
        message: "This form has been saved as a draft.",
        buttons: [
          {
            label: "OK",
            onClick: () => this.goBack()
          }
        ]
      };

      confirmAlert(options);
    } else {
      let msg = "This form has been submitted";
      if (this.props.approval_enabled) {
        msg =
          "This form has been sent to " + this.state.approver + " for approval";
      }

      const options = {
        title: "Confirmation",
        message: msg,
        buttons: [
          {
            label: "OK",
            onClick: () => this.goBack(true)
          }
        ]
      };

      confirmAlert(options);
    }
  }

  elementExisits(element_id) {
    var exists = _.filter(this.props.draft, { element_id: element_id }).length;
    return exists === 1 ? true : false;
  }

  handleAddRepeatingForm(controls) {
    this.props.actions.addRepeatingForm(this.props.repeatingFormUUID, controls);
  }

  handleRemove() {
    if (this.props.repeatingFormEdit) {
      this.props.actions.deleteRepeatingFormItem();
      this.setState({ repeatingFormControls: [] });
    } else {
      this.handleCloseModal();
    }
  }

  handleChange(
    repeatingForm,
    element_id,
    element_value,
    base64,
    galleryImage,
    barcode = false
  ) {
    const { sessionId, deviceId } = this.props;
    const { isDraft, outbox } = this.props.match.params;

    let draft = false;
    if (isDraft !== undefined || outbox !== undefined) {
      draft = true;
    }

    if (
      element_value.indexOf("/png") !== -1 ||
      element_value.indexOf(".png") !== -1
    ) {
      if (element_value.indexOf(".png") !== -1) {
        this.props.actions.uploadSignature(
          draft,
          repeatingForm ? this.props.repeatingFormId : -1,
          repeatingForm ? this.props.repeatingFormUUID : -1,
          repeatingForm ? this.props.repeatingFormIndex : -1,
          element_id,
          "",
          base64,
          deviceId,
          sessionId,
          this.state.uuid,
          this.controls
        );
      } else {
        this.props.actions.uploadSignature(
          draft,
          repeatingForm ? this.props.repeatingFormId : -1,
          repeatingForm ? this.props.repeatingFormUUID : -1,
          repeatingForm ? this.props.repeatingFormIndex : -1,
          element_id,
          element_value,
          base64,
          deviceId,
          sessionId,
          this.state.uuid,
          this.controls
        );
      }
    } else {
      if (element_value.indexOf("/jpeg") !== -1) {
        if (element_value === "/jpeg") {
          element_value = base64;
        }
        this.props.actions.uploadImage(
          draft,
          repeatingForm ? this.props.repeatingFormId : -1,
          repeatingForm ? this.props.repeatingFormUUID : -1,
          repeatingForm ? this.props.repeatingFormIndex : -1,
          element_id,
          element_value,
          base64,
          deviceId,
          sessionId,
          this.state.uuid,
          galleryImage,
          this.controls
        );
      } else {
        let test = _.filter(this.props.formControls, function(draft) {
          return (
            draft.element_condition.action === "show" ||
            draft.element_condition.action === "hide"
          );
        });

        let show = "";

        let xRepeatingFormId = repeatingForm ? this.props.repeatingFormId : -1;
        let xRepeatingFormUUID = repeatingForm
          ? this.props.repeatingFormUUID
          : -1;
        let xRepeatingFormIndex = repeatingForm
          ? this.props.repeatingFormIndex
          : -1;
        let xControls = this.controls;

        let xA = [];

        test.forEach(elementr => {
          show = "";
          let h = elementr.element_condition.action;

          elementr.element_condition.roles.forEach(rolex => {
            if (Number(rolex.c_control) === Number(element_id)) {
              show = CheckRule(show, element_value, rolex);

              show = (" " + show).replace("  && ", "").replace("  || ", "");

              if (eval(show)) {
                if (h === "hide") {
                  show = "false";
                }
              } else {
                if (h === "hide") {
                  show = "true";
                }
              }
            }
          });

          if (show === "") {
            show = "true";
          } else {
            show = (" " + show).replace("  && ", "").replace("  || ", "");
          }

          let ok = true;
          if (show.trim() === "") {
            ok = false;
          }

          if (!eval(show) && ok) {
            let test2 = _.filter(this.props.formControls, function(draft) {
              return (
                Number(draft.element_parent) === Number(elementr.element_id)
              );
            });

            if (test2.length === 0) {
              let ei = _.filter(this.props.draft, function(draft) {
                if (draft.repeatingFormIndex === undefined) {
                  return (
                    Number(draft.element_id) === Number(elementr.element_id)
                  );
                } else {
                  return (
                    Number(draft.element_id) === Number(elementr.element_id) &&
                    draft.repeatingFormIndex === xRepeatingFormIndex
                  );
                }
              });

              if (ei.length > 0) {
                if (ei.length > 1) {
                  ei = _.filter(ei, function(draft) {
                    return draft.repeatingFormEdit === true;
                  });
                  if (ei[0].element_value !== undefined) {
                    if (ei[0].element_value !== "") {
                      xA.push({ element_id: elementr.element_id });
                    }
                  }
                } else {
                  if (ei[0].element_value !== undefined) {
                    if (ei[0].element_value !== "") {
                      xA.push({ element_id: elementr.element_id });
                    }
                  }
                }
              }
            } else {
              test2.forEach(element => {
                let ei = _.filter(this.props.draft, function(draft) {
                  if (draft.repeatingFormIndex === undefined) {
                    return (
                      Number(draft.element_id) === Number(element.element_id)
                    );
                  } else {
                    return (
                      Number(draft.element_id) === Number(element.element_id) &&
                      draft.repeatingFormIndex === xRepeatingFormIndex
                    );
                  }
                });

                if (ei.length > 0) {
                  if (ei.length > 1) {
                    ei = _.filter(ei, function(draft) {
                      return draft.repeatingFormEdit === true;
                    });
                    if (ei[0].element_value !== undefined) {
                      if (ei[0].element_value !== "") {
                        xA.push({ element_id: element.element_id });
                      }
                    }
                  } else {
                    if (ei[0].element_value !== undefined) {
                      if (ei[0].element_value !== "") {
                        xA.push({ element_id: element.element_id });
                      }
                    }
                  }
                }
              });
            }
          }
        });

        if (xA.length > 0) {
          const options = {
            title: "Confirm",
            message: "Do you want to clear the values of hidden fields?",
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  xA.forEach(element => {
                    this.props.actions.updateForm(
                      xRepeatingFormId,
                      xRepeatingFormUUID,
                      xRepeatingFormIndex,
                      element.element_id,
                      "",
                      xControls,
                      barcode
                    );
                  });
                  this.props.actions.updateForm(
                    xRepeatingFormId,
                    xRepeatingFormUUID,
                    xRepeatingFormIndex,
                    element_id,
                    element_value,
                    xControls,
                    barcode
                  );
                }
              },
              {
                label: "No",
                onClick: () => {
                  this.props.actions.updateForm(
                    xRepeatingFormId,
                    xRepeatingFormUUID,
                    xRepeatingFormIndex,
                    element_id,
                    element_value,
                    xControls,
                    barcode
                  );
                }
              },
              {
                label: "Cancel",
                onClick: () => {}
              }
            ]
          };

          confirmAlert(options);
        }

        if (xA.length === 0) {
          if (eval(show) || show === "" || xA.length === 0) {
            this.props.actions.updateForm(
              repeatingForm ? this.props.repeatingFormId : -1,
              repeatingForm ? this.props.repeatingFormUUID : -1,
              repeatingForm ? this.props.repeatingFormIndex : -1,
              element_id,
              element_value,
              this.controls,
              barcode
            );
          }
        }
      }
    }
  }

  handleError() {
    this.props.actions.updateFormErrors(true);
  }

  renderFormSections() {
    if (this.props.isLoading) {
      return (
        <div className="formSectionContainer" style={{ height: "1500px" }}>
          <form className="ui form">
            <br />
            <br />
            <br />
            <br />
            <br />
            <Loader active size="large" inline="centered">
              Loading
            </Loader>
          </form>
        </div>
      );
    }

    const { formControls, draft, errors, validate } = this.props;
    return (
      <div style={{ paddingBottom: this.tablet ? "40px" : "155px" }}>
        {this.state.formControls}
      </div>
    );
  }

  handleCloseModal() {
    this.props.actions.cancelRepeatingForm();
    this.setState({ repeatingFormControls: [] });
  }

  handleClose() {
    this.setState({
      approverModalVisible: false,
      loading: false,
      filterText: ""
    });
  }

  getHierarchyControls(nFormControls, formControlsOrdered, i) {
    nFormControls.forEach(element => {
      if (global.x[i] === undefined) {
        global.x.push([element]);
      } else {
        Array.prototype.push.apply(global.x[i], [element]);
      }
      var nFormControls2 = _.filter(formControlsOrdered, function(user) {
        return (
          Number(user.element_parent) === Number(element.element_id) &&
          Number(element.element_type) !== 22
        );
      });

      if (nFormControls2.length > 0) {
        this.getHierarchyControls(nFormControls2, formControlsOrdered, i);
      }
    });
  }

  getRepeatingFormSections(formControlsOrdered, parentId) {
    var isPage = false;
    var page = 1;
    global.y = [];

    var formControlsFiltered = _.filter(formControlsOrdered, function(user) {
      return Number(user.element_parent) === Number(parentId);
    });

    var i = 0;

    var init = true;
    if (global.y.length > 0) {
      init = false;
    }
    let repeatingFormEdit = this.props.repeatingFormEdit;
    let draftx = this.props.draft;
    let uuid = this.props.repeatingFormUUID;

    formControlsFiltered.forEach((formControl, index) => {
      if (formControl.element_type !== "25") {
        let element = _.filter(draftx, function(draft) {
          return (
            Number(draft.element_id) === Number(formControl.element_id) &&
            draft.repeatingFormUUID === uuid
          );
        });
        let value = "";

        if (element.length > 1) {
          element = _.filter(element, function(draft) {
            return (
              draft.repeatingFormEdit ===
              (repeatingFormEdit === undefined ? undefined : repeatingFormEdit)
            );
          });
        }

        if (element.length === 1) {
          value = element[0].element_value;
        }
        let newIndex = parentId + "_" + index;

        var setPage = -1;
        if (isPage) {
          page += 1;
          setPage = page;
        }

        if (init) {
          var nFormControls = _.filter(formControlsOrdered, function(user) {
            return (
              Number(user.element_parent) === Number(formControl.element_id) &&
              Number(formControl.element_type) !== 22
            );
          });

          if (nFormControls.length === 0) {
            global.y.push({});
          } else {
            this.getHierarchyRepeatingControls(
              nFormControls,
              formControlsOrdered,
              i
            );
          }
        }

        nFormControls = global.y[i];

        i += 1;

        element = "";
        let value_x = "";
        let show = "";

        switch (formControl.element_condition.action) {
          case "":
            this.state.repeatingFormControls.push(
              <FormSection
                tablet={this.tablet}
                setMandatory={this.handleSetMandatory.bind(this)}
                clearSectionMandatory={this.handleClearSectionMandatory.bind(
                  this
                )}
                repeatingForm={true}
                index={"r" + i}
                repeatingFormEdit={this.props.repeatingFormEdit}
                repeatingFormId={this.props.repeatingFormId}
                repeatingFormUUID={this.props.repeatingFormUUID}
                storeColour={this.props.storeColour}
                isLoading={this.props.isControlLoading}
                active_element={this.props.active_element}
                formControl={formControl}
                page={setPage}
                validate={this.props.repeatingFormValidate}
                errors={this.props.repeatingFormErrors}
                draft={this.props.draft}
                formControls={nFormControls}
                element_value={value}
                onChange={this.handleChange.bind(this)}
                key={newIndex}
              />
            );
            break;
          case "show":
            formControl.element_condition.roles.forEach(elementr => {
              element = _.filter(draftx, function(draft) {
                return (
                  Number(draft.element_id) === Number(elementr.c_control) &&
                  draft.repeatingFormUUID === uuid
                );
              });

              if (element.length > 1) {
                element = _.filter(element, function(draft) {
                  return (
                    draft.repeatingFormEdit ===
                    (repeatingFormEdit === undefined
                      ? undefined
                      : repeatingFormEdit)
                  );
                });
              }

              if (element.length === 1) {
                value_x = element[0].element_value;
              }

              show = CheckRule(show, value_x, elementr);
            });
            if (show === "") {
              show = false;
            } else {
              show = (" " + show).replace("  && ", "").replace("  || ", "");
            }
            if (eval(show)) {
              this.state.repeatingFormControls.push(
                <FormSection
                  tablet={this.tablet}
                  setMandatory={this.handleSetMandatory.bind(this)}
                  clearSectionMandatory={this.handleClearSectionMandatory.bind(
                    this
                  )}
                  repeatingForm={true}
                  index={"r" + i}
                  repeatingFormEdit={this.props.repeatingFormEdit}
                  repeatingFormId={this.props.repeatingFormId}
                  repeatingFormUUID={this.props.repeatingFormUUID}
                  storeColour={this.props.storeColour}
                  isLoading={this.props.isControlLoading}
                  active_element={this.props.active_element}
                  formControl={formControl}
                  page={setPage}
                  validate={this.props.repeatingFormValidate}
                  errors={this.props.repeatingFormErrors}
                  draft={this.props.draft}
                  formControls={nFormControls}
                  element_value={value}
                  onChange={this.handleChange.bind(this)}
                  key={newIndex}
                />
              );
            } else {
              this.handleClearSectionMandatory("r" + i);
            }

            break;
          case "hide":
            formControl.element_condition.roles.forEach(elementr => {
              element = _.filter(draftx, function(draft) {
                return (
                  Number(draft.element_id) === Number(elementr.c_control) &&
                  draft.repeatingFormUUID === uuid
                );
              });

              if (element.length > 1) {
                element = _.filter(element, function(draft) {
                  return (
                    draft.repeatingFormEdit ===
                    (repeatingFormEdit === undefined
                      ? undefined
                      : repeatingFormEdit)
                  );
                });
              }

              if (element.length === 1) {
                value_x = element[0].element_value;
              }

              show = CheckRule(show, value_x, elementr);
            });
            if (show === "") {
              show = false;
            } else {
              show = (" " + show).replace("  && ", "").replace("  || ", "");
            }
            if (!eval(show)) {
              this.state.repeatingFormControls.push(
                <FormSection
                  tablet={this.tablet}
                  setMandatory={this.handleSetMandatory.bind(this)}
                  clearSectionMandatory={this.handleClearSectionMandatory.bind(
                    this
                  )}
                  repeatingForm={true}
                  index={"r" + i}
                  repeatingFormEdit={this.props.repeatingFormEdit}
                  repeatingFormId={this.props.repeatingFormId}
                  repeatingFormUUID={this.props.repeatingFormUUID}
                  storeColour={this.props.storeColour}
                  isLoading={this.props.isControlLoading}
                  active_element={this.props.active_element}
                  formControl={formControl}
                  page={setPage}
                  validate={this.props.repeatingFormValidate}
                  errors={this.props.repeatingFormErrors}
                  draft={this.props.draft}
                  formControls={nFormControls}
                  element_value={value}
                  onChange={this.handleChange.bind(this)}
                  key={newIndex}
                />
              );
            } else {
              this.handleClearSectionMandatory("r" + i);
            }

            break;
        }
      }

      if (formControl.element_type === "25") {
        isPage = true;
      } else {
        isPage = false;
      }
    });
  }

  handleClosePreview() {
    this.props.actions.setSubmitting(false);
    this.setModalVisible(false);
    this.setState({ numPages: 0 });
    this.props.actions.updatePreview_go("");
  }

  setModalVisible(visible) {
    this.setState({ modalVisible: visible });
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages: numPages });
  };

  renderModal() {
    const { form_title, form_version } = this.props.match.params;

    return (
      <ReactModal
        isOpen={this.state.modalVisible}
        style={customStylesPreview}
        contentLabel="Example Modal"
        onRequestClose={() => {
          //alert('Modal has been closed.');
        }}
      >
        <Header
          storeColour={this.props.storeColour}
          onCloseModal={this.handleClosePreview.bind(this)}
          modal={true}
          preview={true}
          onBack={this.handleBack.bind(this)}
          backLink={"/forms"}
          formTitle={form_title}
          formVersion={form_version}
        ></Header>
        <Document
          file={this.props.preview}
          onLoadSuccess={this.onDocumentLoadSuccess}
        >
          {_.range(1, this.state.numPages + 1, 1).map(page => (
            <Page pageNumber={page} width={window.outerWidth} />
          ))}
        </Document>
      </ReactModal>
    );
  }

  getHierarchyRepeatingControls(nFormControls, formControlsOrdered, i) {
    nFormControls.forEach(element => {
      if (global.y[i] === undefined) {
        global.y.push([element]);
      } else {
        Array.prototype.push.apply(global.y[i], [element]);
      }
      var nFormControls2 = _.filter(formControlsOrdered, function(user) {
        return (
          Number(user.element_parent) === Number(element.element_id) &&
          Number(element.element_type) !== 22
        );
      });

      if (nFormControls2.length > 0) {
        this.getHierarchyRepeatingControls(
          nFormControls2,
          formControlsOrdered,
          i
        );
      }
    });
  }

  renderRepeatingFormModal(formControlsOrdered) {
    if (this.props.repeatingFormId !== -1) {
      this.controls = [];
      this.state.repeatingFormControls = [];
      this.getRepeatingFormSections(
        formControlsOrdered,
        this.props.repeatingFormId
      );
      this.state.repeatingFormControls.forEach(element => {
        this.controls.push(element.props.formControl.element_id);
        if (element.props.formControls.length > 0) {
          element.props.formControls.forEach(element2 => {
            this.controls.push(element2.element_id);
          });
        }
      });
    }

    var hx = window.innerHeight * 0.85 - 100;

    return (
      <ReactModal
        isOpen={this.props.repeatingFormId === -1 ? false : true}
        style={customStyles}
        contentLabel="Example Modal"
        onRequestClose={() => {
          //alert('Modal has been closed.');
        }}
      >
        <div>
          <Header
            storeColour={this.props.storeColour}
            modal={true}
            onCloseModal={this.handleCloseModal.bind(this)}
            preview={false}
            backLink={"/forms"}
            formTitle={this.props.repeatingFormTitle}
          ></Header>
          <div
            id="divScroll"
            className="formBackgroundModal"
            style={{
              height: hx,
              zIndex: 300,
              "min-height": "0",
              overflowY: "scroll",
              "-webkit-overflow-scrolling": "touch"
            }}
          >
            <div>{this.state.repeatingFormControls}</div>
            <br />
            <br />
          </div>

          <div style={{ position: "absolute", bottom: "0px", width: "100%" }}>
            <table
              width={"100%"}
              className="MainHeader"
              border={0}
              cellPadding={0}
              cellSpacing={0}
            >
              <tbody>
                <tr style={{ height: "50px" }}>
                  <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                    <button
                      onClick={this.handleRemove.bind(this)}
                      className="ui button submit"
                      style={{
                        paddingLeft: "35px",
                        width: "100px",
                        float: "left"
                      }}
                      role="button"
                    >
                      <i
                        style={{
                          left: "20px",
                          color: "var(--main-bg-color)",
                          position: "absolute",
                          fontSize: "14px"
                        }}
                        className="minus icon"
                      ></i>{" "}
                      Remove
                    </button>
                    <button
                      onClick={this.handleAddRepeatingForm.bind(
                        this,
                        this.controls
                      )}
                      className="ui button submit"
                      style={{ width: "100px", float: "right" }}
                      role="button"
                    >
                      Done
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ReactModal>
    );
  }

  checkReady(isDraft, draftName) {
    if (1 === 2) {
      setTimeout(() => {
        this.checkReady(isDraft, draftName);
      }, 1000);
    } else {
      this.confirmSubmit(isDraft, draftName);
    }
  }

  confirmSubmit(isDraft, draftName) {
    this.submitForm(isDraft, draftName);
  }

  submitForm(isDraft, draftName = "") {
    const { sessionId, draft, deviceId, approval_enabled } = this.props;
    const { form_id, result_id, uuid, notification_id } = this.props.match.params;

    // check if sent item, open as new form
    let resultId = result_id;
    if (uuid.indexOf("!") !== -1) {
      resultId = "";
    }

    let copy = this.props.match.params.uuid.indexOf("!") !== -1;
    if (
      !this.props.isGeolocationAvailable ||
      !this.props.isGeolocationEnabled
    ) {
      this.props.actions.submitForm(
        copy,
        draftName,
        sessionId,
        form_id,
        draft,
        deviceId,
        this.state.uuid,
        isDraft,
        resultId,
        this.controls,
        "",
        "",
        this.props.match.params.isDraft !== undefined ||
          this.props.match.params.outbox !== undefined
          ? true
          : false,
        approval_enabled,
        notification_id
      );
    } else {
      var lat = this.props.coords.latitude;
      var long = this.props.coords.longitude;
      this.props.actions.submitForm(
        copy,
        draftName,
        sessionId,
        form_id,
        draft,
        deviceId,
        this.state.uuid,
        isDraft,
        resultId,
        this.controls,
        lat,
        long,
        this.props.match.params.isDraft !== undefined ||
          this.props.match.params.outbox !== undefined
          ? true
          : false,
        approval_enabled,
        notification_id
      );
    }
  }

  setDraftModalVisible(visible) {
    this.setState({ draftModalVisible: visible });
  }

  mobileMenu = (show) => {
    this.setState({ showMenu: show });
  }

  renderDraft() {
    var isApprover =
      this.props.match.params.approver === undefined ||
      this.props.match.params.approver === "false"
        ? false
        : true;
    if (isApprover) {
      return (
        <button
          onClick={() => this.handleSubmit(true)}
          className="ui button submit"
          style={{ marginBottom: 10 }}
          role="button"
        >
          Save as Draft
        </button>
      );
    }

    return null;
  }

  renderMobileMenu() {

    if (!this.tablet && this.state.showMenu) {
      const preview = this.props.preview === "" ? false : true;

      const { selectedForm } = this.props
      const previewEnabled=selectedForm && selectedForm.preview;
      const tasksEnabled=selectedForm && selectedForm.tasks;
      return (
        <div
          className="ButtonFooter menu-active"
          style={{
            width: "100%",
            zIndex: 1000,
            position: "fixed",
            bottom: "0px",
            left: "0px"
          }}
        >
          <table cellSpacing="10px" style={{ width: "100%" }}>
            <tr>
              <td style={{ textAlign: "center", width: "100%" }}>
                {tasksEnabled && (<button
                  className="ui button submit"
                  style={{ marginBottom: 10 }}
                  role="button"
                  onClick={this.handleCreateTask}
                >
                  Create Task
                </button>)}
                {previewEnabled && (<button
                  className="ui button submit"
                  style={{ marginBottom: 10 }}
                  role="button"
                  onClick={this.handlePreview}
                >
                  {this.props.submitting && preview ? "Cancel" : "Preview1"}
                </button>)}
                {this.renderDraft()}
                <button
                  onClick={() => this.mobileMenu(false)}
                  className="ui button submit"
                  style={{ marginBottom: 10 }}
                  role="button"
                >
                  Cancel
                </button>
              </td>
            </tr>
          </table>
        </div>
      );
    }

    return null;
  }

  handleSubmit(draft) {
    const { form_title, outbox, isDraft, uuid } = this.props.match.params;

    if (draft) {
      if (
        isDraft === undefined ||
        outbox !== undefined ||
        uuid.indexOf("!") !== -1
      ) {
        this.setDraftModalVisible(true);
      } else {
        this.props.actions.setSubmitting(true);
        this.checkReady(true, form_title);
      }
      this.setState({ isDraft: true });
    } else {
      const options = {
        title: "Confirm",
        message: "Are you sure you want to submit this form?",
        buttons: [
          {
            label: "OK",
            onClick: () => {
              if (this.props.approval_enabled) {
                //show modal approver list
                this.setState({ approverModalVisible: true, draft: draft });
              } else {
                this.props.actions.setSubmitting(true);
                this.checkReady(draft, "");
              }
            }
          },
          {
            label: "Cancel",
            onClick: () => {}
          }
        ]
      };

      confirmAlert(options);
    }
  }

  updateDimensions() {
    let update_width = window.outerWidth;
    let update_height = window.outerHeight;
    this.setState({ width: update_width, height: update_height });
  }

  handleSetMandatory(section, elementId) {
    this.props.actions.setMandatory(section, elementId);
  }

  handlePreview = () => {
    const { draft } = this.props;
    const { form_id } = this.props.match.params;

    if (this.props.submitting) {
      this.props.actions.abortFetching();
    } else {
      this.props.actions.updatePreview_go("[fetching]");
      this.props.actions.setSubmitting(true);

      this.props.actions.submitFormPreview(form_id, draft);
    }
  }

  handleClearSectionMandatory(section) {
    this.props.actions.clearSectionMandatory(section);
  }

  getFormSections(formControlsOrdered, parentId) {
    var page = 0;

    var formControlsFiltered = _.filter(formControlsOrdered, function(user) {
      return user.element_parent === parentId;
    });

    var i = 0;
    var p = 0;
    var init = true;
    if (global.x.length > 0) {
      init = false;
    }
    formControlsFiltered.forEach((formControl, index) => {
      if (formControl.element_type !== "25") {
        let element = _.filter(this.props.draft, function(draft) {
          return Number(draft.element_id) === Number(formControl.element_id);
        });
        let value = "";

        if (element.length === 1) {
          value = element[0].element_value;
        }
        let newIndex = parentId + "_" + index;

        var setPage = 1;
        page += 1;
        setPage = page;

        if (init) {
          var nFormControls = _.filter(formControlsOrdered, function(user) {
            return (
              Number(user.element_parent) === Number(formControl.element_id) &&
              Number(formControl.element_type) !== 22
            );
          });

          if (nFormControls.length === 0) {
            global.x.push({});
          } else {
            this.getHierarchyControls(nFormControls, formControlsOrdered, i);
          }
        }

        nFormControls = global.x[i];

        i += 1;

        element = "";
        let value_x = "";
        let show = "";

        switch (formControl.element_condition.action) {
          case "":
            this.state.pageNums.push(1);
            this.state.formControls.push(
              <FormSection
                tablet={this.tablet}
                setMandatory={this.handleSetMandatory.bind(this)}
                clearSectionMandatory={this.handleClearSectionMandatory.bind(
                  this
                )}
                ref={"FormSection" + i}
                next={true}
                index={i}
                repeatingForm={false}
                storeColour={this.props.storeColour}
                isLoading={this.props.isControlLoading}
                active_element={this.props.active_element}
                formControl={formControl}
                page={setPage}
                validate={this.props.validate}
                errors={this.props.errors}
                draft={this.props.draft}
                formControls={nFormControls}
                element_value={value}
                onChange={this.handleChange.bind(this)}
                key={newIndex}
              />
            );
            break;
          case "show":
            formControl.element_condition.roles.forEach(elementr => {
              element = _.filter(this.props.draft, function(draft) {
                return Number(draft.element_id) === Number(elementr.c_control);
              });

              if (element.length === 1) {
                value_x = element[0].element_value;
              }

              show = CheckRule(show, value_x, elementr);
            });
            if (show === "") {
              show = false;
            } else {
              show = (" " + show).replace("  && ", "").replace("  || ", "");
            }
            if (eval(show)) {
              this.state.pageNums.push(1);
              this.state.formControls.push(
                <FormSection
                  tablet={this.tablet}
                  setMandatory={this.handleSetMandatory.bind(this)}
                  clearSectionMandatory={this.handleClearSectionMandatory.bind(
                    this
                  )}
                  ref={"FormSection" + i}
                  next={true}
                  index={i}
                  repeatingForm={false}
                  storeColour={this.props.storeColour}
                  isLoading={this.props.isControlLoading}
                  active_element={this.props.active_element}
                  formControl={formControl}
                  page={setPage}
                  validate={this.props.validate}
                  errors={this.props.errors}
                  draft={this.props.draft}
                  formControls={nFormControls}
                  element_value={value}
                  onChange={this.handleChange.bind(this)}
                  key={newIndex}
                />
              );
            } else {
              this.handleClearSectionMandatory(i);
              this.state.pageNums.push(0);
            }

            break;
          case "hide":
            formControl.element_condition.roles.forEach(elementr => {
              element = _.filter(this.props.draft, function(draft) {
                return Number(draft.element_id) === Number(elementr.c_control);
              });

              if (element.length === 1) {
                value_x = element[0].element_value;
              }

              show = CheckRule(show, value_x, elementr);
            });
            if (show === "") {
              show = false;
            } else {
              show = (" " + show).replace("  && ", "").replace("  || ", "");
            }
            if (!eval(show)) {
              this.state.pageNums.push(1);
              this.state.formControls.push(
                <FormSection
                  tablet={this.tablet}
                  setMandatory={this.handleSetMandatory.bind(this)}
                  clearSectionMandatory={this.handleClearSectionMandatory.bind(
                    this
                  )}
                  ref={"FormSection" + i}
                  next={true}
                  index={i}
                  repeatingForm={false}
                  storeColour={this.props.storeColour}
                  isLoading={this.props.isControlLoading}
                  active_element={this.props.active_element}
                  formControl={formControl}
                  page={setPage}
                  validate={this.props.validate}
                  errors={this.props.errors}
                  draft={this.props.draft}
                  formControls={nFormControls}
                  element_value={value}
                  onChange={this.handleChange.bind(this)}
                  key={newIndex}
                />
              );
            } else {
              this.handleClearSectionMandatory(i);
              this.state.pageNums.push(0);
            }

            break;
        }
      }

      if (formControl.element_type === "25") {
        let c = i;
        let cd = this.state.pageNums.length;
        for (let index = 1; index < cd - p; index++) {
          this.state.pageNums.pop();
        }
        p += 1;
        //isPage = true;
      } else {
        //isPage = false;
      }
    });
  }

  //Remove event listener
  componentWillUnmount() {
    const list = ReactDOM.findDOMNode(this.refs.divScrollx);
    list.removeEventListener("scroll", this._handleScroll.bind(this));
  }

  handleRenameDraft(name) {
    this.setDraftModalVisible(false);

    this.props.actions.setSubmitting(true);
    this.checkReady(true, name);
  }

  handleApproveRejectDraft(note) {
    const { result_id } = this.props.match.params;
    this.props.actions.postStatusHistory(
      result_id,
      this.state.status,
      note,
      "Form"
    );
  }

  renderApproveRejectModal() {
    if (this.state.approveRejectModalVisible) {
      const { report_title } = this.props;

      return (
        <ReactModal
          isOpen={this.state.approveRejectModalVisible}
          style={customStylesApproval}
          contentLabel="Example Modal"
          onRequestClose={() => {
            //alert('Modal has been closed.');
          }}
        >
          <div
            style={{
              paddingTop: 40,
              backgroundColor: "white",
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 6,
              width: "100%",
              height: "100%"
            }}
          >
            <Icon
              type="MaterialIcons"
              onClick={() =>
                this.setState({ approveRejectModalVisible: false })
              }
              style={{
                position: "absolute",
                right: "20px",
                top: "20px",
                color: "#e6e6e6",
                cursor: "pointer"
              }}
              size="large"
              name="close"
            />
            <ApproveReject
              postingStatus={this.props.postingStatus}
              storeColour={this.props.storeColour}
              form_title={report_title}
              onApproveReject={this.handleApproveRejectDraft.bind(this)}
            />
          </div>
        </ReactModal>
      );
    } else {
      return null;
    }
  }

  renderDraftModal() {
    const { form_title } = this.props.match.params;

    return (
      <ReactModal
        isOpen={this.state.draftModalVisible}
        style={customStylesRename}
        contentLabel="Example Modal"
        onRequestClose={() => {
          //alert('Modal has been closed.');
        }}
      >
        <div
          style={{
            paddingTop: 40,
            backgroundColor: "white",
            paddingLeft: 20,
            paddingRight: 20,
            borderRadius: 6,
            width: "100%",
            height: "100%"
          }}
        >
          <Icon
            type="MaterialIcons"
            onClick={() => this.setState({ draftModalVisible: false })}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              color: "#e6e6e6",
              cursor: "pointer"
            }}
            size="large"
            name="close"
          />
          <RenameDraft
            tablet={this.tablet}
            form_title={form_title}
            onRenameDraft={this.handleRenameDraft.bind(this)}
          />
        </div>
      </ReactModal>
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.isLoading && nextProps.formControls.length > 0) {
      return false;
    }

    return true;
  }

  handleApprove() {
    this.setState({ approveRejectModalVisible: true, status: 3 });
  }

  handleReject() {
    this.setState({ approveRejectModalVisible: true, status: 2 });
  }

  renderPages(pages) {
    let y = this.state.height - 50;
    var isApprover =
      this.props.match.params.approver === undefined ||
      this.props.match.params.approver === "false"
        ? false
        : true;

    if (this.tablet) {
      const { selectedForm } = this.props

      return (
        <Pages
          isApprover={isApprover}
          exists={this.props.exists}
          onReject={this.handleReject.bind(this)}
          onApprove={this.handleApprove.bind(this)}
          draft={this.props.draft}
          isReady={this.props.isReady}
          isConnected={this.props.isConnected}
          submitting={this.props.submitting}
          onPreview={this.handlePreview}
          onCreateTask={this.handleCreateTask}
          pageNums={this.state.pageNums}
          onSubmit={this.handleSubmit.bind(this)}
          pages={pages}
          height={y}
          previewEnabled={selectedForm && selectedForm.preview}
          tasksEnabled={selectedForm && selectedForm.tasks}
        ></Pages>
      );
    }

    return null;
  }

  renderMobileButtons() {
    if (!this.tablet) {
      return (
        <div
          className="ButtonFooter"
          style={{
            width: "100%",
            zIndex: 400,
            position: "fixed",
            bottom: "0px",
            height: "58px",
            left: "0px"
          }}
        >
          <table cellSpacing="10px" style={{ width: "100%" }}>
            <tr>
              <td style={{ textAlign: "center", width: "60px" }}>
                <Button
                  onClick={() => this.mobileMenu(true)}
                  icon="ellipsis horizontal"
                  style={{
                    width: "50px",
                    height: "36px",
                    backgroundColor: "white",
                    marginRight: "0px",
                    marginBottom: "15px"
                  }}
                />
              </td>
              <td style={{ textAlign: "center", width: "50%" }}>
                <button
                  onClick={this.handleSubmit.bind(this, true)}
                  className="ui button submit"
                  style={{ marginBottom: 15 }}
                  role="button"
                >
                  Save as draft
                </button>
              </td>
              <td style={{ textAlign: "center", width: "50%" }}>
                <button
                  onClick={this.handleSubmit.bind(this, false)}
                  className="ui button submit"
                  style={{ marginBottom: 15 }}
                  role="button"
                >
                  Submit
                </button>
              </td>
            </tr>
          </table>
        </div>
      );
    }

    return null;
  }

  handleScroll(page) {
    let pg = page;

    var position = _.filter(this.refs.testScroll._listRef._frames, {
      index: pg
    });

    if (position.length === 0) {
      this.refs.testScroll.scrollToEnd();
    } else {
      if (pg === 0) {
        this.refs.testScroll.scrollToOffset({ offset: 0 });
      } else {
        this.refs.testScroll.scrollToOffset({ offset: position[0].offset });
      }
    }
  }

  renderMobilePages(pages) {
    if (!this.tablet) {
      return (
        <div
          id="abcd"
          className="formBackground_mh"
          style={{
            height: "90px",
            "-webkit-overflow-scrolling": "touch",
            minHeight: "0px",
            overflowX: "scroll"
          }}
        >
          <MobilePages
            pageNums={this.state.pageNums}
            storeColour={this.props.storeColour}
            onClick={this.handleScroll.bind(this)}
            pages={pages}
          ></MobilePages>
        </div>
      );
    }

    return null;
  }

  handleChangeApprover(e, d) {
    const { form_id } = this.props.match.params;
    var approverData = _.filter(this.props.approverArray, {
      formId: Number(form_id)
    });
    let approverA = _.filter(approverData[0].data[0].users, { user_id: e });
    let approver =
      approverA[0].user_firstname + " " + approverA[0].user_lastname;

    this.setState({
      approverModalVisible: false,
      approver: approver
    });

    this.checkReady(this.state.draft, "");
  }

  handleFilter(e) {
    let fd = "";
    this.setState({ filterText: e.target.value });
  }

  renderApprovalModal() {
    if (this.state.approverModalVisible) {
      let h = window.innerHeight * 0.85 - 70 - 44;

      const { approverArray } = this.props;
      const { form_id } = this.props.match.params;

      var filterString = this.state.filterText;

      var approverData = _.filter(approverArray, { formId: Number(form_id) });
      var optionsDataInit = [];
      approverData[0].data[0].users.forEach(element => {
        if (
          (element.user_firstname + " " + element.user_lastname)
            .toLowerCase()
            .indexOf(filterString.toLowerCase()) !== -1 ||
          filterString === ""
        ) {
          optionsDataInit.push(
            <div
              onClick={this.handleChangeApprover.bind(this, element.user_id)}
              className="rows"
            >
              {element.user_firstname + " " + element.user_lastname}
            </div>
          );
        }
      });

      return (
        <ReactModal
          isOpen={this.state.approverModalVisible}
          style={customStylesApp}
          contentLabel="Example Modal"
          onRequestClose={() => {
            //alert('Modal has been closed.');
          }}
        >
          <div
            className="hrl"
            style={{
              width: "100%",
              height: "44px",
              lineHeight: "44px",
              backgroundColor: "white"
            }}
          >
            <div
              style={{
                paddingLeft: "0px",
                paddingTop: "5px",
                marginBottom: "0px",
                paddingBottom: "0px"
              }}
              className="ui form formControlItem"
            >
              <Form.Field>
                <input
                  type="text"
                  style={{ border: "none" }}
                  onChange={this.handleFilter.bind(this)}
                  value={this.state.filterText}
                  placeholder="Filter..."
                />
              </Form.Field>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: h + "px",
              overflowY: "auto",
              borderBottomLeftRadius: "5px",
              borderBottomRightRadius: "5px",
              backgroundColor: "rgb(230, 230, 230)"
            }}
          >
            {optionsDataInit}
          </div>
          <div style={{ textAlign: "center", width: "100%", height: "50px" }}>
            <button
              onClick={this.handleClose.bind(this)}
              className="ui button submit"
              style={{ position: "relative", width: "100px", bottom: "-30px" }}
              role="button"
            >
              Cancel
            </button>
          </div>
        </ReactModal>
      );
    }
  }

  handleCreateTask = () => {
    this.setState({ taskEditModal: true })
  }

  onCloseTaskModal = () => {
    this.setState({ 
      taskEditModal: false ,
      showMenu: false
    })
  }

  renderTaskModal = () => {
    const { selectedForm } = this.props
    return (<div>
    {this.state.taskEditModal && 
      <TaskEditor
      onClose={this.onCloseTaskModal}   
      formId={selectedForm && selectedForm.form_id}
    />}
  </div>)};  

  renderOverlay() {
    if (this.state.showMenu) {
      return (
        <div
          style={{
            flex: 1,
            position: "absolute",
            height: 1500,
            zIndex: 500,
            left: 0,
            top: 0,
            opacity: 0.5,
            backgroundColor: "black",
            width: window.innerWidth
          }}
        />
      );
    }

    return null;
  }

  _handleScroll(ev) {
    document.activeElement.blur();
  }

  render() {
    const { formControls } = this.props;
    const { form_title, form_version, recovered } = this.props.match.params;

    global.x = [];
    global.y = [];

    let x = this.state.width - 210 + "px";

    var formControlsOrdered = _.sortBy(formControls, function(obj) {
      return parseInt(obj.element_position, 10);
    });

    this.state.formControls = [];
    this.state.pageNums = [];

    this.getFormSections(formControlsOrdered, 0);
    if (this.props.repeatingFormId === -1) {
      this.controls = [];

      this.state.formControls.forEach(element => {
        this.controls.push(element.props.formControl.element_id);
        if (element.props.formControls.length > 0) {
          element.props.formControls.forEach(element2 => {
            this.controls.push(element2.element_id);
          });
        }
      });
    }

    this.state.formControls.push(<div style={{ height: 500 }} />);

    let pages = _.filter(formControlsOrdered, function(user) {
      return user.element_parent === 0;
    });

    return (
      <div>
        {this.renderRepeatingFormModal(formControlsOrdered)}
        {this.renderDraftModal()}
        {this.renderModal()}
        {this.renderApproveRejectModal()}
        {this.renderApprovalModal()}
        {this.renderTaskModal()}
        <Header
          backLink={"/forms"}
          onBack={this.handleBack.bind(this)}
          recovered={recovered}
          formTitle={form_title}
          formVersion={form_version}
        ></Header>
        {this.renderPages(pages)}
        {this.renderMobilePages(pages)}
        <div
          id="divScroll"
          ref="divScrollx"
          className={this.tablet ? "formBackground" : "formBackground_m"}
          style={{
            float: "right",
            zIndex: 300,
            position: "absolute",
            top: this.tablet ? "auto" : "106px",
            left: this.tablet ? "210px" : "0px",
            height: "100%",
            overflowY: "scroll",
            WebkitOverflowScrolling: "touch"
          }}
        >
          {this.renderFormSections()}
        </div>
        {this.renderMobileButtons()}
        {this.renderOverlay()}
        {this.renderMobileMenu()}
      </div>
    );
  }
}

FormContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  formControls: PropTypes.array.isRequired,
  draft: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  validate: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  sessionId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  formControls: state.form.data,
  draft: state.form.draft,
  title: state.form.title,
  approverArray: state.formArray.approver,
  version: state.form.version,
  active_element: state.form.active_element,
  isControlLoading: state.form.isLoading,
  deviceId: state.informedWebApp.deviceId,
  submitted: state.form.submitted,
  preview: state.form.preview,
  submitting: state.form.submitting,
  formControlArray: state.formArray,
  validate: state.form.validate,
  repeatingFormValidate: state.form.repeatingFormValidate,
  errors: state.form.errors,
  approval_enabled: state.form.approval_enabled,
  repeatingFormErrors: state.form.repeatingFormErrors,
  sessionId: state.informedWebApp.sessionId,
  isLoading: state.informedWebApp.isLoading,
  showMsg: state.form.showMsg,
  exists: state.form.exists,
  showMsgRepeat: state.form.showMsgRepeat,
  isReady: state.informedWebApp.isReady,
  postingStatus: state.form.postingStatus,
  repeatingFormId: state.form.repeatingFormId,
  repeatingFormUUID: state.form.repeatingFormUUID,
  repeatingFormIndex: state.form.repeatingFormIndex,
  repeatingFormEdit: state.form.repeatingFormEdit,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  repeatingFormTitle: state.form.repeatingFormTitle,
  recovered_formId: state.forms.recovered_formId,
  recovered_draft: state.forms.recovered_draft,
  isConnected: state.informedWebApp.isConnected,
  imageQueue: state.informedWebApp.imageQueue,
  actionQueue: state.informedWebApp.actionQueue,
  storeColour: state.informedWebApp.storeColour,
  selectedForm: state.forms.data.find(form => form.form_id === state.form.formId),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  compose(
    connect(
      mapStateToProps,
      mapDispatchToProps
    ),
    geolocated({
      positionOptions: {
        enableHighAccuracy: false
      },
      userDecisionTimeout: 5000
    })
  )(FormContainer)
);



// WEBPACK FOOTER //
// ./src/containers/FormContainer/index.js